import { Routes, Route, Navigate } from "react-router-dom";
import AuthDomainSignIn from "../../views/auth/signin/auth-domain-signin";
import AuthDomainSignUp from "../../views/auth/signup/auth-domain-signup";
import AuthDomainForgotPassword from "../../views/auth/forgot-password/auth-domain-forgot-password";
import AuthValidationError from "../../views/auth/auth-validation-error";
import RegistrationSuccess from "../../views/auth/registration-success/registration-success";
import GooglePickerPage from "../../views/auth/google-picker/google-picker";
import GoogleAuthPage from "../../views/auth/google-auth/google-auth";
import OneDriveAuthPage from "../../views/auth/onedrive-auth/onedrive-auth";
import OneDrivePickerPage from "../../views/auth/onedrive-picker/onedrive-picker";

/**
 * Routes configuration for the login domain (login.kenbakke.com)
 * Only authentication-related routes are available on this domain
 */
export const AuthDomainRoutes = () => {
    return (
        <Routes>
            <Route path="/login" element={<AuthDomainSignIn />} />
            <Route path="/registration" element={<AuthDomainSignUp />} />
            <Route path="/forgot-password" element={<AuthDomainForgotPassword />} />
            <Route path="/registration-success" element={<RegistrationSuccess />} />
            <Route path="/error" element={<AuthValidationError />} />

            {/* Google Picker for cross-domain Drive selection (multi-tenant support) */}
            <Route path="/google-picker" element={<GooglePickerPage />} />

            {/* Google Auth for cross-domain OAuth (multi-tenant support) */}
            <Route path="/google-auth" element={<GoogleAuthPage />} />

            {/* OneDrive Auth for cross-domain OAuth (multi-tenant support) */}
            <Route path="/onedrive-auth" element={<OneDriveAuthPage />} />

            {/* OneDrive Picker for cross-domain file selection (multi-tenant support) */}
            <Route path="/onedrive-picker" element={<OneDrivePickerPage />} />

            {/* Redirect root to login */}
            <Route path="/" element={<Navigate to="/login" replace />} />

            {/* Redirect all other routes to login (don't show error for OAuth popups) */}
            <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
    );
};
